import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage, unsafeTranslationKey, TranslationKey } from 'intl';
import { DocumentationTranslationKeys } from 'intl/keys';

import CloseIcon from '@mui/icons-material/Close';
import { ReactElement } from 'react';
import {
  useDirectoryForm,
  withDirectoryForm,
} from 'components/dataCreationForms/withDirectoryForm';
import { DirectoryWizard } from '.';

const useStyles = makeStyles({
  root: {
    '& .MuiDialog-paper': {
      margin: 16,
      width: '100%',
    },
  },
  dialogContent: {
    padding: 0,
  },
  closeIcon: {
    opacity: 0.54,
    cursor: 'pointer',
  },
  dialogTitle: {
    padding: '16px',
    '& .MuiTypography-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: '18px',
    },
  },
});

function DirectoryWizardDialog(): ReactElement | null {
  const { directory, isOpen, closeDialog } = useDirectoryForm();
  const classes = useStyles();

  return (
    <Dialog
      className={classes.root}
      open={isOpen}
      keepMounted={false}
      onClose={closeDialog}
    >
      <DialogTitle className={classes.dialogTitle}>
        {directory ? (
          <FormattedMessage id={DocumentationTranslationKeys.editDirectory} />
        ) : (
          <FormattedMessage id={DocumentationTranslationKeys.createDirectory} />
        )}
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        <DirectoryWizard name={directory?.name} />
      </DialogContent>
    </Dialog>
  );
}

export const DirectoryDialog = withDirectoryForm(DirectoryWizardDialog);
